<script>
    import {sgettext} from '../../../i18n.js';
    export let row = null
</script>

{row.document_number}

{#if row.activity_version.template_status === 'Draft'}
    <span class="template-status template-status-draft">{sgettext('$$DRAFT$$')}</span>
{/if}